import NorthWestIcon from '@mui/icons-material/NorthWest';
import { Box, IconButton, Link, Typography } from '@mui/material';
import React from 'react';
import logoImg from '../images/ICICILE03.png';

const Footer = () => {
	const handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	return (
		<Box
			component='footer'
			sx={{
				backgroundColor: 'rgba(0, 0, 0, 0.9)',
				color: '#ffffff', // Text color
				// pt:6,
				pt: { xs: 2, md: 4 },
				pb: 2, // Padding on top and bottom
				px: 8, // Horizontal padding
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				position: 'relative',
			}}>
			{/* Copyright Text */}
			<Typography
				variant='body2'
				sx={{
					fontSize: { xs: 6, md: 15, sm: 12 },
				}}>
				© Copyright 2026. All rights reserved{' '}
				<Link
					href='#'
					underline='none'
					sx={{ color: '#0F758E' }}>
					Trillium Sourcing Corporation
				</Link>
			</Typography>

			<Typography
				sx={{
					fontSize: { xs: 6, md: 15, sm: 12 },
				}}>
				{' '}
				Powered by{' '}
				<Link
					href='https://iciclecorporation.com/'
					target='_blank'
					underline='none'
					sx={{
						color: '#0F758E',
						'&:hover': {
							textDecoration: 'underline', // Add underline on hover
						},
					}}>
					<img
						src={logoImg}
						alt="Logo"
						style={{ height: 16, marginBottom: -3, marginRight: 3 }}
					/>
					icicle corporation
				</Link>
			</Typography>

			{/* Floating Button */}
			<IconButton
				onClick={handleScrollToTop}
				sx={{
					backgroundColor: '#0F758E',
					color: '#ffffff',
					position: 'absolute',
					right: 16,
					bottom: '35%',
					fontWeight: { xs: '5px' },
					transform: 'translateY(50%)', // Center the button vertically
					'&:hover': {
						backgroundColor: 'white',
						color: '#0F758E',
					},
				}}>
				<NorthWestIcon />
			</IconButton>
		</Box>
	);
};

export default Footer;
